import BaseIvrNode, { EMPTY_NEXT_ID_MESSAGE, EMPTY_ERROR_ID_MESSAGE } from './baseIvrNode';
import { IsString, IsOptional, IsNotEmpty } from 'class-validator';

export default class VariableNode extends BaseIvrNode {
  @IsString()
  @IsOptional()
  expression?: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_NEXT_ID_MESSAGE })
  nextId: string;

  @IsString()
  @IsNotEmpty({ message: EMPTY_ERROR_ID_MESSAGE })
  errorNodeId: string;
}
